var map = {
	"./Swap&Bridge-dark.png": "c2e0",
	"./Swap&Bridge-m-dark.png": "e414",
	"./Swap&Bridge-m.png": "0b2a",
	"./Swap&Bridge.png": "0bf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6267";